module.exports = __webpack_public_path__ + "static/media/Coventry.aa1d0342.webp";